import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.tsx';
import { AvisoDeVersion } from './componentes/AvisoDeVersion.tsx';
import { OfertaDeInstalar } from './componentes/OfertaDeInstalar.tsx';
import { ProveedorDeIdioma } from './nucleo/idioma.tsx';
import { ProveedorDeSesion } from './nucleo/sesion.tsx';
import './estilos/fuentes.css';
import './estilos/tokens.css';
import './estilos/base.css';
import './estilos/componentes.css';

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <BrowserRouter>
      {/* El idioma envuelve a la sesion: la pantalla de acceso ya es bilingue,
          y alguien que no lee espanol no puede quedarse mirando un formulario
          que no entiende para poder cambiarlo despues de entrar. */}
      <ProveedorDeIdioma>
        <ProveedorDeSesion>
          {/* ▶ FUERA de `App`, y a propósito: `App` tiene cuatro salidas
              tempranas antes del enrutador, así que un aviso puesto adentro
              sólo saldría en una de ellas. Acá sale en las cinco. */}
          <AvisoDeVersion />
          <OfertaDeInstalar />
          <App />
        </ProveedorDeSesion>
      </ProveedorDeIdioma>
    </BrowserRouter>
  </StrictMode>,
);
